import { createFileRoute, redirect } from '@tanstack/react-router'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { Route as NewRoute } from 'routes/process-data/view'

export const Route = createFileRoute(
  '/process-data/(deprecated_routes)/$siteID/view'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: NewRoute.to,
      search: (prev) => ({
        ...prev,
        [SEARCH_PARAM_SITE_ID]: params.siteID,
      }),
      replace: true,
    })
  },
})
